import Link from "../Link";

const Git = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/10" title={"OpenBootcamp Git"} />
            <Link url="https://www.youtube.com/watch?v=HiXLkL42tMU" title={"Git y GitHub Desde 0 - Fazt"} />
        </div>
    );
}

export default Git;